import { vuexfireMutations, firestoreAction } from 'vuexfire'
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import axios from 'axios';

var CLOUD_FUNCTIONS_URL = process.env.VUE_APP_CLOUD_FUNCTIONS_URL
CLOUD_FUNCTIONS_URL = `https://us-central1-ml-saas.cloudfunctions.net`
const BASE_URL_INFERENCE_API = 'https://us-central1-ml-saas.cloudfunctions.net/backend/inference' //`https://nccpvs9fqa.execute-api.us-east-2.amazonaws.com/v1/inference`
// AutoNLP-app
const INFERENCE_API_KEY = 'LoU6v3NmsR3aFg4LgrU6g7FKCHR4CfJS8bkAZci6'
const publicUserId = "7FdDooPKoxZ7EI2jrSOzZ3zKHxI3"
const OPENAI_API_KEY = 'sk-1OswRloiueVcbwSEf9bVDuirGOCb2HtRdk9LCCKI'

const actions = {
    async createModel(_, model) {
        model.createdAt = firebase.firestore.FieldValue.serverTimestamp()
        model.userId = firebase.auth().currentUser.uid
        model.public = false
        const doc_ref = await firebase.firestore().collection(`models`).add(model)
        return doc_ref.id
    },
    deleteModel(_, modelId) {
        firebase.firestore().doc(`models/${modelId}`).delete()
    },
    updateModel(_, { modelId, update }) {
        firebase.firestore().doc(`models/${modelId}`).update(update)
    },
    async train(_, modelId) {
        await axios.post(
          `${CLOUD_FUNCTIONS_URL}/backend/model-training/${modelId}`
        )
    },
    async getModelInferenceBatch(_, payload) {

        let time1 = performance.now();
        let urls = {
            "other": `${process.env.VUE_APP_PIPELINE_URL}/v1/inference-batch`,
            "classification": `${process.env.VUE_APP_INFERENCE_URL}/v1/inference-batch`,
            'answering': `${process.env.VUE_APP_PIPELINE_URL}/v1/answering`,
            'generation': `${process.env.VUE_APP_PIPELINE_URL}/v1/generation`,
        }
        let type = payload.type
        
        if (!urls[type]){
            type = "other"
        }
        
        payload.base_url = urls[type]
        
        let response = await axios.post(
            `${CLOUD_FUNCTIONS_URL}/backend/inference/${payload.modelId}`, 
            payload
        )
        // console.log(payload.base_url)
        // console.log(response.data)
        if ("results" in response.data){
            return {"results": response.data["results"]}
        } else {
            return {"error": `Ops. Please try again.`}
        }
    },
    currentModel: firestoreAction(({ bindFirestoreRef }, modelId) => {

        return bindFirestoreRef('currentModel', firebase.firestore().doc(`models/${modelId}`), {wait: true})
  
    }),
    projectModels: firestoreAction(({ bindFirestoreRef, state }, projectId) => {
      
        return bindFirestoreRef('projectModels', 
          firebase.firestore()
            .collection(`models`)
            .where('projectId', '==', projectId)
            .orderBy('createdAt', 'desc')
            .limit(10)
        )
    }),
    // ADMIN
    retrieveAllModelsAdmin: firestoreAction(({ bindFirestoreRef, state }) => {
      
        let userModels = bindFirestoreRef('modelsAdmin', 
          firebase.firestore().collection(`projects`)
          //.where('userId', 'in', [firebase.auth().currentUser.uid])
          .orderBy('createdAt', 'desc')
          .limit(100)
        )
        
  
        return userModels
      }),
      retrieveAllModels: firestoreAction(({ bindFirestoreRef, state }) => {
      
        if (state.modelsAdmin) {
          return
        }
        let models = bindFirestoreRef('models', 
          firebase.firestore().collection(`models`)
          .where('userId', 'in', [firebase.auth().currentUser.uid])
          .orderBy('createdAt', 'desc')
        )
  
        return models
      }),
      retrievePublicModels: firestoreAction(({ bindFirestoreRef, state }) => {
      
        if (state.publicModels) {
          return
        }
        let publicModels = bindFirestoreRef('publicModels', 
          firebase.firestore().collection(`models`)
          .where('public', '==', true)
          .orderBy('createdAt', 'desc')
        )
  
        return publicModels
      }),
}

export default actions